import { render, staticRenderFns } from "./ExportData.vue?vue&type=template&id=32918aaf"
import script from "./ExportData.vue?vue&type=script&lang=js"
export * from "./ExportData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32918aaf')) {
      api.createRecord('32918aaf', component.options)
    } else {
      api.reload('32918aaf', component.options)
    }
    module.hot.accept("./ExportData.vue?vue&type=template&id=32918aaf", function () {
      api.rerender('32918aaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Data/ExportData.vue"
export default component.exports